var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('form-progress'),_vm._v(" "),_c('div',{staticClass:"nav"},[_c('div',{staticClass:"form-button",on:{"click":function($event){return _vm.$emit('back')}}},[_vm._v("Precedente")]),_vm._v(" "),(_vm.percent<100)?_c('div',{staticClass:"form-button",on:{"click":function($event){return _vm.$emit('next')}}},[_vm._v("Successivo")]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }